import {
  BaseReducerState,
  DeleteItemAPIResponse,
  Item,
} from '../../../services'
import { ActionTypes } from '../actions'

export type DeleteItemState = BaseReducerState & {
  data: Item | null
}

export const initialState: DeleteItemState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const deleteItem = (
  state: DeleteItemState = initialState,
  action: { type: string; res: any }
): DeleteItemState => {
  switch (action.type) {
    case `${ActionTypes.DELETE_STOCK_ITEM}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.DELETE_STOCK_ITEM}_SUCCESS`: {
      const { success, data, message } = <DeleteItemAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
      }
    }
    case `${ActionTypes.DELETE_STOCK_ITEM}_FAILURE`:
      const res = <DeleteItemAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.DELETE_STOCK_ITEM}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
